import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SignInButton from '@/components/SignInButton.vue';
const authenticationModule = namespace('authentication');
const userModule = namespace('user');
let UserProfile = class UserProfile extends Vue {
    constructor() {
        super(...arguments);
        this.username = '';
        this.userLoading = true;
        this.userSubmitting = false;
        this.submittedSuccesfully = false;
    }
    async created() {
        if (this.isLoggedIn) {
            await this.getUser();
            this.username = this.user.username;
        }
        this.userLoading = false;
    }
    async updateUser() {
        this.submittedSuccesfully = false;
        this.userSubmitting = true;
        await this.postUser({ username: this.username });
        this.submittedSuccesfully = true;
        this.userSubmitting = false;
    }
    usernameFieldUpdated() {
        this.submittedSuccesfully = false;
    }
};
__decorate([
    authenticationModule.State
], UserProfile.prototype, "accessToken", void 0);
__decorate([
    authenticationModule.State
], UserProfile.prototype, "isAuthLoading", void 0);
__decorate([
    authenticationModule.Getter
], UserProfile.prototype, "isLoggedIn", void 0);
__decorate([
    userModule.Action
], UserProfile.prototype, "getUser", void 0);
__decorate([
    userModule.Action
], UserProfile.prototype, "postUser", void 0);
__decorate([
    userModule.State
], UserProfile.prototype, "user", void 0);
UserProfile = __decorate([
    Component({
        components: {
            SignInButton
        }
    })
], UserProfile);
export default UserProfile;
